import "core-js/modules/esnext.array.group.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
import api from "@/api";
import config from "@/config/fileSelect";
import { ElMessage, ElMessageBox } from 'element-plus';
import { ref, reactive } from "vue";
export default {
    __name: 'group',
    emits: [
        "success",
        "closed"
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        const emit = __emit;
        const mode = ref('add');
        const titleMap = reactive({
            add: "新增分类",
            edit: "编辑分类"
        });
        const visible = ref(false);
        const isSaveing = ref(false);
        const form = ref({
            group_name: '',
            parent_id: 0
        });
        const parentList = ref([]);
        const rules = reactive({
            group_name: [
                {
                    required: true,
                    message: "请输入分类名称"
                }
            ]
        });
        const open = (row = "add", data = {})=>{
            if (data.id) {
                form.value = Object.assign(form.value, data);
            }
            mode.value = row;
            getList();
            visible.value = true;
        };
        const dialogForm = ref(null);
        const getList = async ()=>{
            const res = await config.menuApiObj.post();
            if (res?.code === 1) {
                parentList.value = [
                    {
                        id: 0,
                        group_name: '顶级分类'
                    },
                    ...res.data
                ];
            }
        };
        const submit = ()=>{
            dialogForm.value.validate(async (valid)=>{
                if (valid) {
                    const buildData = {
                        ...form.value
                    };
                    isSaveing.value = true;
                    let res = await api.common.file.group.save.post(buildData);
                    isSaveing.value = false;
                    if (res?.code === 1) {
                        emit("success");
                        visible.value = false;
                        ElMessage.success("操作成功");
                    } else {
                        ElMessageBox(res.message, "提示", {
                            type: "error"
                        });
                    }
                } else {
                    return false;
                }
            });
        };
        __expose({
            open
        });
        // export default {
        // 	emits: ["success", "closed"],
        // 	data() {
        // 		return {
        // 			mode: "add",
        // 			titleMap: {
        // 				add: "新增分类",
        // 				edit: "编辑分类",
        // 			},
        // 			visible: false,
        // 			isSaveing: false,
        // 			//表单数据
        // 			form: {
        // 				group_name: "",
        // 			},
        // 			//验证规则
        // 			rules: {
        // 				group_name: [{ required: true, message: "请输入分类名称" }],
        // 			},
        // 		};
        // 	},
        // 	mounted() { },
        // 	methods: {
        // 		//显示
        // 		open(mode = "add") {
        // 			this.mode = mode;
        // 			this.visible = true;
        // 			return this;
        // 		},
        // 		//表单提交方法
        // 		submit() {
        // 			this.$refs.dialogForm.validate(async (valid) => {
        // 				if (valid) {
        // 					this.isSaveing = true;
        // 					var res = await this.$API.user.withdrawa.addAndEdit.post();
        // 					this.isSaveing = false;
        // 					if (res?.code === 1) {
        // 						this.$emit("success", this.form, this.mode);
        // 						this.visible = false;
        // 						this.$message.success("操作成功");
        // 					} else {
        // 						this.$alert(res.message, "提示", { type: "error" });
        // 					}
        // 				} else {
        // 					return false;
        // 				}
        // 			});
        // 		},
        // 		//表单注入数据
        // 		setData(data) {
        // 			Object.assign(this.form, data);
        // 		},
        // 	},
        // };
        return (_ctx, _cache)=>{
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_form_item = _resolveComponent("el-form-item");
            const _component_el_option = _resolveComponent("el-option");
            const _component_el_select = _resolveComponent("el-select");
            const _component_el_form = _resolveComponent("el-form");
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_dialog = _resolveComponent("el-dialog");
            return _openBlock(), _createBlock(_component_el_dialog, {
                title: titleMap[mode.value],
                modelValue: visible.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>visible.value = $event),
                "align-center": "",
                width: 600,
                "destroy-on-close": "",
                onClosed: _cache[5] || (_cache[5] = ($event)=>_ctx.$emit('closed'))
            }, {
                footer: _withCtx(()=>[
                        _createVNode(_component_el_button, {
                            onClick: _cache[2] || (_cache[2] = ($event)=>visible.value = false)
                        }, {
                            default: _withCtx(()=>[
                                    ..._cache[6] || (_cache[6] = [
                                        _createTextVNode("取 消", -1)
                                    ])
                                ]),
                            _: 1
                        }),
                        _createVNode(_component_el_button, {
                            type: "primary",
                            loading: isSaveing.value,
                            onClick: _cache[3] || (_cache[3] = ($event)=>submit())
                        }, {
                            default: _withCtx(()=>[
                                    ..._cache[7] || (_cache[7] = [
                                        _createTextVNode(" 确 认 ", -1)
                                    ])
                                ]),
                            _: 1
                        }, 8, [
                            "loading"
                        ])
                    ]),
                default: _withCtx(()=>[
                        _createVNode(_component_el_form, {
                            model: form.value,
                            rules: rules,
                            disabled: mode.value == 'show',
                            ref_key: "dialogForm",
                            ref: dialogForm,
                            "label-width": "130px",
                            "label-position": "left"
                        }, {
                            default: _withCtx(()=>[
                                    _createVNode(_component_el_form_item, {
                                        label: "分类名称",
                                        prop: "group_name"
                                    }, {
                                        default: _withCtx(()=>[
                                                _createVNode(_component_el_input, {
                                                    modelValue: form.value.group_name,
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>form.value.group_name = $event),
                                                    placeholder: "请输入分类名称",
                                                    clearable: ""
                                                }, null, 8, [
                                                    "modelValue"
                                                ])
                                            ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                        label: "上级分类",
                                        prop: "parent_id"
                                    }, {
                                        default: _withCtx(()=>[
                                                _createVNode(_component_el_select, {
                                                    modelValue: form.value.parent_id,
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>form.value.parent_id = $event),
                                                    placeholder: "默认顶级",
                                                    clearable: ""
                                                }, {
                                                    default: _withCtx(()=>[
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parentList.value, (item)=>{
                                                                return _openBlock(), _createBlock(_component_el_option, {
                                                                    key: item.id,
                                                                    label: item.group_name,
                                                                    value: item.id
                                                                }, null, 8, [
                                                                    "label",
                                                                    "value"
                                                                ]);
                                                            }), 128))
                                                        ]),
                                                    _: 1
                                                }, 8, [
                                                    "modelValue"
                                                ])
                                            ]),
                                        _: 1
                                    })
                                ]),
                            _: 1
                        }, 8, [
                            "model",
                            "rules",
                            "disabled"
                        ])
                    ]),
                _: 1
            }, 8, [
                "title",
                "modelValue"
            ]);
        };
    }
};
